import * as z from 'zod';

export const resetPasswordSchema = z.object({
    loginId: z
        .string()
        .min(4, "아이디는 4자 이상이어야 합니다")
        .max(16, "아이디는 16자 이하이어야 합니다")
        .nonempty("아이디를 입력해주세요"),
    name: z
        .string()
        .min(2, "이름은 2자 이상이어야 합니다")
        .max(10, "이름은 10자 이하이어야 합니다")
        .nonempty("이름을 입력해주세요"),
    phoneNumber: z
        .string()
        .regex(/^010\d{8}$/, "전화번호 형식으로 입력해주세요 (예: 01012345678)")
        .nonempty("전화번호를 입력해주세요"),
    authNumber: z
        .string()
        .length(6, '인증번호는 6자리여야 합니다.')
        .regex(/^[0-9]{6}$/, "숫자만 입력해주세요")
        .optional(),
});

export const resetPasswordSchema2 = z.object({
    password: z
        .string()
        .regex(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/,
            "비밀번호는 영어, 숫자, 특수문자(@,$,!,%,*,#,?,&)를 포함한 8자 이상 16자 이하이어야 합니다"
        ),
    passwordConfirm: z.string(),
});